export const EMR_VISITS_RETRIEVE_REQUESTED = 'EMR_VISITS_RETRIEVE_REQUESTED';
export const EMR_VISITS_RETRIEVE_SUCCEED = 'EMR_VISITS_RETRIEVE_SUCCEED';
export const EMR_VISITS_RETRIEVE_FAILED = 'EMR_VISITS_RETRIEVE_FAILED';

export const EMR_VISIT_RETRIEVE_REQUESTED = 'EMR_VISIT_RETRIEVE_REQUESTED';
export const EMR_VISIT_RETRIEVE_SUCCEED = 'EMR_VISIT_RETRIEVE_SUCCEED';
export const EMR_VISIT_RETRIEVE_FAILED = 'EMR_VISIT_RETRIEVE_FAILED';

export const EMR_VISIT_ADD_REQUESTED = 'EMR_VISIT_ADD_REQUESTED';
export const EMR_VISIT_ADD_SUCCEED = 'EMR_VISIT_ADD_SUCCEED';
export const EMR_VISIT_ADD_FAILED = 'EMR_VISIT_ADD_FAILED';

export const EMR_VISITS_LAST_RETRIEVE_REQUESTED = 'EMR_VISITS_LAST_RETRIEVE_REQUESTED';
export const EMR_VISITS_LAST_RETRIEVE_SUCCEED = 'EMR_VISITS_LAST_RETRIEVE_SUCCEED';
export const EMR_VISITS_LAST_RETRIEVE_FAILED = 'EMR_VISITS_LAST_RETRIEVE_FAILED';

export const EMR_VISITS_RESET_STATUS = 'EMR_VISITS_RESET_STATUS';
